import type { Root } from 'react-dom/client'

/** Own one script's pending startup and React tree, including external DOM removal. */
export function createAgentLifetime(script: HTMLScriptElement) {
  const controller = new AbortController()
  let host: HTMLElement | undefined
  let root: Root | undefined
  let disposed = false

  const dispose = () => {
    if (disposed) return
    disposed = true
    observer.disconnect()
    controller.abort()
    try {
      root?.unmount()
    } finally {
      host?.remove()
    }
  }

  const observer = new MutationObserver(() => {
    if (!script.isConnected || (host && !host.isConnected)) dispose()
  })
  observer.observe(document.documentElement, { childList: true, subtree: true })

  return {
    signal: controller.signal,
    get active() { return !disposed && script.isConnected },
    get mounted() { return !!root && !disposed },
    attach(nextHost: HTMLElement, nextRoot: Root) {
      if (disposed) {
        nextRoot.unmount()
        nextHost.remove()
        return false
      }
      host = nextHost
      root = nextRoot
      if (!script.isConnected || !host.isConnected) {
        dispose()
        return false
      }
      return true
    },
    dispose,
  }
}
